import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { deleteDB, openDB } from 'idb';
import { assertIsArray, isString } from '@dateam/ark';

// export type TableDescriptors<Db> =
//     Db extends IdbSchema<infer _> ? (
//         {
//             [P in keyof Db extends infer T ? (
//                 T extends string ?
//                 (
//                     T extends keyof Db ?
//                     Db[T] extends Table ? T : never
//                     : never
//                 )
//                 : never
//             )
//             : never]: (
//                 // {
//                 //     name: P;
//                 //     keyPath: A;
//                 //     autoIncrement?: IDBObjectStoreParameters['autoIncrement'];
//                 // }
//                 Db[P] extends TableWithConfig<infer A, infer _> ? TableWithConfigDescriptor<P, A>
//                 : Db[P] extends TableWithDefaultConfig<infer _> ? TableWithDefaultConfigDescriptor<P>
//                 : never
//             )
//         } extends {
//             [P in keyof Db extends infer T ? (
//                 T extends string ?
//                 (
//                     T extends keyof Db ?
//                     Db[T] extends Table ? T : never
//                     : never
//                 )
//                 : never
//             )
//             : never]: infer U;
//         } ? U[]
//         : never
//     )
//     : never;
var IndexedDbProvider = /*#__PURE__*/function () {
  function IndexedDbProvider(database) {
    _classCallCheck(this, IndexedDbProvider);
    this.database = void 0;
    this.db = void 0;
    this.isOpen = void 0;
    this.isSupported = true;
    this.database = database;
    if (!('indexedDB' in window)) {
      console.warn('This browser doesn\'t support IndexedDB');
      this.isSupported = false;
    }
  }
  return _createClass(IndexedDbProvider, [{
    key: "createObjectStore",
    value: function () {
      var _createObjectStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tables) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              assertIsArray(tables, 'IndexedDbProvider: table descriptors are not valid.');
              _context.prev = 1;
              _context.next = 4;
              return openDB(this.database, 1, {
                upgrade: function upgrade(db) {
                  tables.forEach(function (table) {
                    var tableName = isString(table) ? table : table.name;
                    if (db.objectStoreNames.contains(tableName)) return;
                    db.createObjectStore(tableName, {
                      autoIncrement: table === null || table === void 0 ? void 0 : table.autoIncrement,
                      keyPath: table === null || table === void 0 ? void 0 : table.keyPath
                    });
                  });
                }
              });
            case 4:
              this.db = _context.sent;
              this.isOpen = true;
              return _context.abrupt("return", true);
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", false);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 9]]);
      }));
      function createObjectStore(_x) {
        return _createObjectStore.apply(this, arguments);
      }
      return createObjectStore;
    }()
  }, {
    key: "deleteDb",
    value: function () {
      var _deleteDb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return deleteDB(this.database, {
                blocked: function blocked() {
                  return console.warn('blocked');
                }
              });
            case 3:
              _context2.next = 9;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.warn('deleteDb', _context2.t0);
              return _context2.abrupt("return", false);
            case 9:
              return _context2.abrupt("return", true);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function deleteDb() {
        return _deleteDb.apply(this, arguments);
      }
      return deleteDb;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              // console.warn('closeDb open', this.isOpen);
              if (this.isOpen) {
                this.db.close();
                this.isOpen = false;
              }
              _context3.next = 7;
              break;
            case 4:
              _context3.prev = 4;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", false);
            case 7:
              return _context3.abrupt("return", true);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }, {
    key: "getValue",
    value: function () {
      var _getValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tableName, key) {
        var tx, store, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readonly');
              store = tx.objectStore(tableName);
              _context4.next = 4;
              return store.get(key);
            case 4:
              result = _context4.sent;
              return _context4.abrupt("return", result);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getValue(_x2, _x3) {
        return _getValue.apply(this, arguments);
      }
      return getValue;
    }()
  }, {
    key: "getAllValue",
    value: function () {
      var _getAllValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(tableName) {
        var tx, store, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readonly');
              store = tx.objectStore(tableName);
              _context5.next = 4;
              return store.getAll();
            case 4:
              result = _context5.sent;
              return _context5.abrupt("return", result);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getAllValue(_x4) {
        return _getAllValue.apply(this, arguments);
      }
      return getAllValue;
    }()
  }, {
    key: "putValue",
    value: function () {
      var _putValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(tableName, value, key) {
        var tx, store, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readwrite');
              store = tx.objectStore(tableName);
              _context6.prev = 2;
              _context6.next = 5;
              return store.put(value, key);
            case 5:
              result = _context6.sent;
              _context6.next = 8;
              return tx.done;
            case 8:
              return _context6.abrupt("return", result);
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](2);
              console.warn(_context6.t0);
              throw _context6.t0;
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[2, 11]]);
      }));
      function putValue(_x5, _x6, _x7) {
        return _putValue.apply(this, arguments);
      }
      return putValue;
    }()
  }, {
    key: "putBulkValue",
    value: function () {
      var _putBulkValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(tableName, values) {
        var tx, store;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readwrite');
              store = tx.objectStore(tableName);
              _context7.next = 4;
              return Promise.all(values.map(function (value) {
                return store.put(value);
              }));
            case 4:
              return _context7.abrupt("return", this.getAllValue(tableName));
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function putBulkValue(_x8, _x9) {
        return _putBulkValue.apply(this, arguments);
      }
      return putBulkValue;
    }()
  }, {
    key: "deleteValue",
    value: function () {
      var _deleteValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(tableName, key) {
        var tx, store, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readwrite');
              store = tx.objectStore(tableName);
              _context8.next = 4;
              return store.get(key);
            case 4:
              result = _context8.sent;
              if (result) {
                _context8.next = 7;
                break;
              }
              return _context8.abrupt("return", undefined);
            case 7:
              _context8.next = 9;
              return store["delete"](key);
            case 9:
              _context8.next = 11;
              return tx.done;
            case 11:
              return _context8.abrupt("return", key);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function deleteValue(_x10, _x11) {
        return _deleteValue.apply(this, arguments);
      }
      return deleteValue;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tableName) {
        var tx, store;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              tx = this.db.transaction(tableName, 'readwrite');
              store = tx.objectStore(tableName);
              _context9.next = 4;
              return store.clear();
            case 4:
              _context9.next = 6;
              return tx.done;
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function clear(_x12) {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
  }]);
}();
export default IndexedDbProvider;